module.exports = __webpack_public_path__ + "static/media/drone.fdcf3f57.svg";